<template>
  <div class="float-right">
    <div v-if="show">
      <b-spinner small />
    </div>
    <div v-else>
      <h3
        id="popover-balance"
        class="text-danger text-right"
        @click="hidePopover"
      >
        <small
          class="text-dark font-weight"
          style="font-size: 18px"
        >
          Balance al Corte:
        </small>
        {{ formatMoneda(roundNumber(balancecorte, 2)) }}
      </h3>

      <h3
        id="popover-balance"
        class="text-danger text-right"
        @click="hidePopover"
      >
        <small
          class="text-dark font-weight"
          style="font-size: 18px"
        >
          Balance Total:
        </small>
        {{ formatMoneda(roundNumber(balance, 2)) }}
      </h3>
      <div v-if="valor_uso > 0">
        <div v-if="resumen">
          <code style="font-size: 17px">
            Balance: {{ balance }} + Calculo [{{ dia_uso }}]:
            {{ valor_uso }} =
            {{ total }}
          </code>
        </div>
        <div v-else>
          <b-popover
            ref="popover-balance"
            target="popover-balance"
            triggers="hover"
            placement="auto"
          >
            <template #title>
              Desglose de Valores
            </template>
            <li>
              <span>Balance: {{ balance }}</span>
            </li>
            <li>
              <span>
                Calculo [{{ dia_uso }}]: {{ valor_uso }}
              </span>
            </li>
            <li>
              <span>Total: {{ total }}</span>
            </li>
          </b-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { BPopover, BSpinner } from 'bootstrap-vue'

export default {
    components: {
        BSpinner,
        BPopover,
    },
    props: {
        idcontrato: {
            type: Number,
            required: true,
        },
        resumen: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            show: true,
            balance: 0,
            total: 0,
            valor_uso: 0,
            dia_uso: 0,
            balancecorte: 0,
        }
    },
    created() {
        this.searchBalance()
    },
    methods: {
        searchBalance() {
            if (this.idcontrato > 0) {
                this.$http
                    .get('/balance-contract/', {
                        params: {
                            idcontrato: this.idcontrato,
                        },
                    })
                    .then((response) => {
                        this.show = false
                        if (response.data) {
                            this.balance = response.data.data
                            this.balancecorte = response.data.data1
                        }
                    })
                    .catch((error) => {
                        this.show = false
                        console.log(error)
                    })
            }
        },

        hidePopover() {
            this.$root.$emit('bv::hide::popover-balance', 'popover-balance')
        },

        roundNumber(value, precision) {
            if (Number.isInteger(precision)) {
                // eslint-disable-next-line no-restricted-properties
                const shift = Math.pow(10, precision)

                return Math.round(value * shift + 0.00000000000001) / shift
            }

            return Math.round(value)
        },

        formatMoneda(value) {
            const val = (value / 1).toFixed(2).replace(',', '.')

            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
    },
}
</script>

<style></style>
